module.exports = __webpack_public_path__ + "static/media/4 1 Skrivehastighet Intro.eb39d699.mp3";